import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { LoaderService } from '../shared/services/loader.service';
import { LOADER_CONTEXT } from '@app/shared/utils/constants';

export const loadingInterceptorFn: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const loaderType = req.context.get(LOADER_CONTEXT);
  if (loaderType === 'global') {
    loaderService.startLoading();
  }

  return next(req).pipe(
    finalize(() => {
      if (loaderType === 'global') {
        loaderService.stopLoading();
      }
    })
  );
};